import { cn } from '@/lib'
import { type VariantProps, cva } from 'cva'

export const paragraphVariants = cva({
	base: '',
	variants: {
		size: {
			tiny: 'text-xs',
			small: 'text-sm',
			default: 'text-base',
			large: 'text-lg',
			giant: 'text-2xl',
			'3xl': 'text-3xl',
			'4xl': 'text-4xl',
			'5xl': 'text-5xl',
			'6xl': 'text-6xl',
		},
		transform: {
			uppercase: 'uppercase tracking-wider',
			capitalize: 'capitalize',
			lowercase: 'lowercase',
			none: 'normal-case',
		},
		font: {
			mono: 'font-mono',
			sans: 'font-sans',
		},
		weight: {
			light: 'font-light',
			normal: 'font-normal',
			medium: 'font-medium',
			bold: 'font-bold',
			black: 'font-black',
		},
		color: {
			default: '',
			highlight: 'text-purple-700',
			caption: 'text-gray-400',
			error: 'text-red-700',
			success: 'text-teal-600',
			disabled: 'text-gray-300',
			white: 'text-white',
		},
		align: {
			default: '',
			left: 'text-left',
			center: 'text-center',
			right: 'text-right',
		},
	},
	defaultVariants: {
		size: 'default',
		transform: 'none',
		font: 'sans',
		weight: 'medium',
		color: 'default',
		align: 'default',
	},
})

export interface ParagraphProps
	extends Omit<React.HTMLAttributes<HTMLParagraphElement>, 'color'>,
		VariantProps<typeof paragraphVariants> {}

export const Paragraph: React.FC<ParagraphProps> = ({
	className,
	size,
	transform,
	font,
	weight,
	color,
	align,
	...props
}) => (
	<p
		className={cn(
			paragraphVariants({ size, transform, font, weight, color, align }),
			className,
		)}
		{...props}
	/>
)
